import { createFileRoute } from "@tanstack/react-router";

import RewardPanel from "@/components/Loyalty/RewardPanel";

export const Route = createFileRoute("/gym/$venueUuid/loyalty/rewards/create")({
  component: () => <RewardPanel />,
});
